import React from "react";
import Recruit from "pages/Recruit";

// why: 채용 계획 정보를 별도 페이지로 분리하여 지원자 접근성을 개선

const RecruitPlan = () => {
  return (
    <main className="page-sub">
      <h2>채용 계획</h2>
      <Recruit/>
    </main>
  );
};

export default RecruitPlan;


